<div class="leave-balance-detail" [class.probation]="isProbation">

  <!-- Leave Type Balances Table -->
  <div class="leave-type-balances-section" *ngIf="leaveTypeBalances.length > 0">
    <div class="section-label">Leave Type Balances ({{ leaveTypeBalances.length }})</div>
    <div class="leave-type-table-wrapper">
      <table class="leave-type-table">
      <thead>
        <tr>
          <th>{{ 'leave_management.leave_balance_detail.leave_type' | transloco }}</th>
          <th>{{ 'leave_management.leave_balance_detail.allocated' | transloco }}</th>
          <th>{{ 'leave_management.leave_balance_detail.used' | transloco }}</th>
          <th>{{ 'leave_management.leave_balance_detail.carry_forward' | transloco }}</th>
          <th>{{ 'leave_management.leave_balance_detail.final_balance' | transloco }}</th>
          <th *ngIf="hasReservedLeaves">{{ 'leave_management.leave_balance_detail.reserved' | transloco }}</th>
          <th *ngIf="hasReservedLeaves">{{ 'leave_management.leave_balance_detail.available' | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of leaveTypeBalances">
          <td class="leave-type-name">{{ b.leaveTypeName }}</td>
          <td>{{ b.totalAllocated }}</td>
          <td>{{ b.totalUsed }}</td>
          <td>{{ b.carriedForwardLeaves }}</td>
          <td>{{ b.remainingBalance }}</td>
          <td *ngIf="hasReservedLeaves" class="reserved-cell">{{ b.reservedLeaves }}</td>
          <td *ngIf="hasReservedLeaves" class="available-cell">{{ b.availableBalance }}</td>
        </tr>
      </tbody>
      </table>
    </div>
  </div>

  <div class="detail-grid" [class.probation-grid]="isProbation">

    <!-- Planned Leaves -->
    <div class="detail-section">
      <div class="section-label">{{ 'leave_management.leave_balance_detail.planned_leaves' | transloco }}</div>
      <div class="section-content">
        <div class="planned-leaves-list"
             *ngIf="detailData?.plannedLeaves && detailData.plannedLeaves.length > 0">
          <div class="leave-date" *ngFor="let leave of detailData.plannedLeaves">
            {{ leave.date }}
            <span class="lm-status-tag"
                  *ngIf="leave.status"
                  [ngClass]="'lm-status-tag--' + (leave.status || '').toLowerCase()">
              {{ leave.status }}
            </span>
          </div>
        </div>
        <div *ngIf="!detailData?.plannedLeaves || detailData.plannedLeaves.length === 0"
             class="empty-text">-</div>
      </div>
    </div>

    <!-- Leaves Carry Forward (HIDE for PROBATION) -->
    <ng-container *ngIf="!isProbation">
      <div class="detail-section">
        <div class="section-label">{{ 'leave_management.leave_balance_detail.leaves_carry_forward' | transloco }}</div>
        <div class="section-content">
          <ng-container *ngIf="totalCarryForward > 0; else noCarryForward">
            <div class="carry-forward-info">
              <div class="carry-forward-count">{{ totalCarryForward }}</div>
              <div class="carry-forward-note">{{ 'leave_management.leave_balance_detail.from_previous_year' | transloco }}</div>
            </div>
          </ng-container>
          <ng-template #noCarryForward>
            <div class="empty-text">-</div>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <!-- Optional Holidays -->
    <div class="detail-section">
      <div class="section-label">{{ 'leave_management.leave_balance_detail.optional_holidays' | transloco }}</div>
      <div class="section-content">
        <button class="preview-button" (click)="onPreviewOptionalHolidays()">{{ 'leave_management.leave_balance_detail.preview' | transloco }}</button>
      </div>
    </div>

    <!-- Comp Off Days (HIDE for PROBATION) -->
    <ng-container *ngIf="!isProbation">
      <div class="detail-section">
        <div class="section-label">{{ 'leave_management.leave_balance_detail.comp_off_days' | transloco }}</div>
        <div class="section-content">
          <button class="preview-button" (click)="onPreviewCompOffDays()">{{ 'leave_management.leave_balance_detail.preview' | transloco }}</button>
        </div>
      </div>
    </ng-container>

    <!-- Remarks -->
    <div class="detail-section remarks-section">
      <div class="section-label">
        {{ 'leave_management.leave_balance_detail.remarks' | transloco }}
        <!-- <span class="info-icon" *ngIf="isProbation || detailData?.remarks?.hasInfo">
          {{ isProbation ? '+' : 'ⓘ' }}
        </span> -->
      </div>
      <div class="section-content">
        <div *ngIf="isProbation">
          <div class="remarks-note" *ngIf="detailData?.remarks?.text; else noProbationRemark">
            {{ detailData.remarks.text }}
          </div>
          <ng-template #noProbationRemark>
            <div class="remarks-note">{{ 'leave_management.leave_balance_detail.leave_available_after_6_months_probation_period' | transloco }}</div>
          </ng-template>
        </div>
        <div *ngIf="!isProbation">
          <div class="remarks-editor">
            <input
              type="text"
              class="remarks-input"
              [(ngModel)]="remarksDraft"
              [placeholder]="'leave_management.leave_balance_detail.placeholder.enter_remarks' | transloco" />
            <button class="remarks-save-btn" [disabled]="isSavingRemarks" (click)="saveRemarks()">
              {{ isSavingRemarks ? 'Saving...' : 'Save' }}
            </button>
          </div>
          <div class="remarks-view-section" *ngIf="remarksList.length > 0">
            <button class="remarks-view-btn" (click)="openRemarksDialog()">
              <mat-icon>{{ 'leave_management.leave_balance_detail.visibility' | transloco }}</mat-icon>
              <span>View All Remarks ({{ remarksList.length }})</span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
